<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/en/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/en/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">Service Platform of Medical Equipment Development</span></p>'
      //+ '<div style="margin-left : 40px; margin-bottom: 20px"><div style="font-size: 20px;"><b style="color: #033d80; "> | </b> 简介</span></p>'
      + '<p>&nbsp;</p>'

      + '<div id="left" style="float:left ; width:75%; height:100%;">'
      + '<p style="margin-bottom : 20px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Service Platform of Medical Equipment Development is equipped with metal and non-metallic 3D printers, 5-axis CNC center, laser micro-cutting machine, and medical device standard testing systems for electrical safety and electromagnetic compatibility. The platform aims at providing precision manufacturing and quick compliance exami- nation services for advanced medical equipment research and development to acceler- ate the clinical translation of the research achievements to enhance China\'s core com- petitiveness in the field of medical devices production.</sspan></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 18px; ">联系人</span></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 16px; color: #033d80; ">姓名：崔祎赟</span></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 16px; ">邮箱：cyysjtu@sjtu.edu.cn</span></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 16px; ">电话：17740823635</span></p>'
      + '</div>'


      + '<div id="right" style="float:left ; width:25%; height:100%;">'
      + '<p style="margin-left : 40px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/swyxzzjszx4.png" style="float: left; width: 200px; margin-right: 30px; margin-top:0px;" border="0" vspace="0" alt=""></p>'
      + '<p style="margin-left : 75px;text-align: justify"><span style="font-size: 16px;"><b>Director: Kai Xu</b><br>'
      + '</div>'
      + '<p>&nbsp;</p>'

      + '<div>'
      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> &nbsp; Additive Manufacturing Systems&nbsp; </span></p>'
      + '<p style="margin-top : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment: Metal 3D Printer, Nylon SLS 3D Printer, Multi-material MJP 3D Printer, Stereolithography 3D Print- er，Peek Material 3D Printer.</span></p>'
      + '<p style="margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services: 3D printing</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px;color: white; "> &nbsp;&nbsp;&nbsp;Machining Systems &nbsp;&nbsp;&nbsp;</span></p>'
      + '<p style="margin-top : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment: 5-axis CNC Machining Center, Precision Laser Cutting Machine, Precision Laser Welding Machine, Micro-electrical Discharge Machine.</span></p>'
      + '<p style="margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services: Machining services</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> Electromagnetic Compatibility Testing </span></p>'
      + '<p style="margin-top : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment: Test System of Immunity to Conducted Disturbances, Induced by Radio-frequency Fields</span></p>'
      + '<p style=" margin-right : 20px;text-align: justify"><span style="font-size: 16px">Conducted Disturbances Test System</span></p>'
      + '<p style="margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Electrostatic Discharge Immunity Test System</span></p>'
      + '<p style="margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Radiated Emission Test System</span></p>'
      + '<p style="margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Surge immunity/Electrical Fast Transient/Burst Test Generator</span></p>'
      + '<p style="margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services: Provide EMC testing services</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> Testing System for Medical Electrical Device Standards </span></p>'
      + '<p style="margin-top : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment: Laser Tracker, Image-based Dimension Measurement System, Electrical Safety Testing Equipment, Low- temperature Plasma Sterilization Equipment, Ultraviolet Aging Testing Device.</span></p>'
      + '<p style="margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services: Medical electrical device standard testing services.</span></p>'

      + '<p style="text-align: center;"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/medical_equipment_1_en.jpg" style="float: left; width: 800px;" border="0" vspace="0" ></p>'

      + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; border-bottom: solid 3px #033d80;">Contact</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Yiyun Cui</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Email: cyysjtu@sjtu.edu.cn</span></p>'

      + '</div>'

      + '<p>&nbsp;</p>'
},
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
    line-height: 32px;
  }
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Service10/en/index.vue